import React, { useEffect, useState } from 'react';
import './mobnav.css';
import "../navbar/navbar.css";

import Search from '../../images/Search.png';
import User from '../../images/User.png';
import Menu from '../../images/Menu.png';
import { Link, NavLink } from 'react-router-dom';
import bann from '../../images/banner3.png';
import { Dropdown } from 'react-bootstrap';

export default function MobNav(props) {
  const [result, setResult] = useState(false);
  const [search, setSearch] = useState("");
  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  if (user) {
    // console.log(user);
    
    // console.log(user.user._id);
    var id = user.user._id;
  }
  
  const logoD = require("../../images/logo.png");
  const logoM = require("../../images/sidebarlogo.png");



  useEffect(() => {
    //fetch request js?

    if (search.length > 0) {
      setResult(false);
    }

    if (search && search.length > 0) {
      (async () => {
        try {
          const rawResponse = await fetch(
            `https://obelabs.onrender.com/user/search/${search}`,
            {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          const content = await rawResponse.json();
          console.log(content);
          setResult(() => content);
        } catch (error) {
          setResult(false);
        }
      })();
    } else {
      setResult(false);
    }
  }, [search]);


  return (
    <nav id='mob-nav' className=' d-block d-md-none'>
      <div className="mob-nav-top">
        <div className="mob-nav-left">
          <div className="mob-img-c" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"><img src={Menu} className="mob-nav-img" alt="" /></div>
          <div className="mob-nav-title" >
            <Link to='/'><img style={{width: "115px"}} src={logoD} alt="moblogo" /></Link>
          </div>
        </div>
        <div className="mob-nav-right">
          {/* <div className="mob-img-c"><img src={Search} className="mob-nav-img" alt="" /></div> */}
          {id ? <Link to={`/profile/${id}`} className="mob-img-c"><img src={User} className="mob-nav-img" alt="" /></Link> : 
          <Dropdown className="nav-link-lg me-4 mobile-navdrop">
                          <Dropdown.Toggle>
                          <img src={User} className="mob-nav-img" alt="" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <Link to="/student-login" className="w-100">
                                Login as Student
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to="/institute-login" className="w-100">
                              Login as Institute
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to="/student-register">
                              Register as Student
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link to="/institute-register">
                              Register as Institute
                              </Link>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>}
        </div>
      </div>
      <div className={`mob-nav-bottom search ${props.dnone}`}>
        <input placeholder='ObeLabs' type="text" onInput={(e) => setSearch(e.target.value)} />
        {result && (
                  <>
                    <div className="floatingSearch">
                      {result.institute.map((el) => {
                        return (
                          <div>
                            <NavLink
                              variant="primary"
                              className={"link"}
                              to={`/institute/${el.institute_id}`}
                              style={({ isActive }) => ({
                                color: "#00f",
                                padding: "5px 10px",
                              })}
                            >
                              {el.name}
                            </NavLink>
                          </div>
                        );
                      })}
                      {result.course_list.map((el) => {
                        return (
                          <div>
                            <NavLink
                              variant="primary"
                              className={"link"}
                              to={`/course/${el._id}`}
                              style={({ isActive }) => ({
                                color: "#00f",
                                padding: "5px 10px",
                              })}
                            >
                              {el.course}
                            </NavLink>
                          </div>
                        );
                      })}
                      {result.vacancy.map((el) => {
                        return (
                          <div>
                            <NavLink
                              variant="primary"
                              className={"link"}
                              to={`/vacancy-detail/${el._id}`}
                              style={({ isActive }) => ({
                                color: "#00f",
                                padding: "5px 10px",
                              })}
                            >
                              {el.name}
                            </NavLink>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
      </div>
      {/* <div className="banner-img">
        <img src={bann} alt='banner' />
      </div> */}
    </nav>

  )
}
